/**
 * Deploy-time configuration loaded from public/runtime-config.js before the app bundle.
 * Lets Jenkins inject per-target env vars when the build stage is skipped (Artifactory reuse).
 */

export interface AppRuntimeConfig {
  apiUrl?: string;
  extractorApiUrl?: string;
  analysisApiUrl?: string;
  gatewayUrl?: string;
  protocolKbChatUrl?: string;
  protocolKbApiUrl?: string;
  apiDomain?: string;
  brandName?: string;
  applicationUserFacingName?: string;
  publicName?: string;
  applicationPath?: string;
  cssPrefix?: string;
  scssPrefix?: string;
  devServerPort?: string;
  defaultPageSize?: number;
  oktaIssuer?: string;
  oktaClientId?: string;
  themeName?: string;
  idPortalClientAppName?: string;
  idPortalUrl?: string;
  idPortalApiUrl?: string;
}

declare global {
  interface Window {
    __APP_CONFIG__?: AppRuntimeConfig;
  }
}

export function getRuntimeConfig(): AppRuntimeConfig {
  if (typeof window !== 'undefined' && window.__APP_CONFIG__) {
    return window.__APP_CONFIG__;
  }
  return {};
}

function runtimeString(key: keyof AppRuntimeConfig, envKey: string, fallback = ''): string {
  const runtime = getRuntimeConfig()[key];
  if (runtime !== undefined && runtime !== '') {
    return String(runtime);
  }
  return process.env[envKey] || fallback;
}

function runtimeInt(key: 'defaultPageSize', envKey: string, fallback: number): number {
  const runtime = getRuntimeConfig()[key];
  if (typeof runtime === 'number' && Number.isFinite(runtime)) {
    return runtime;
  }
  const raw = parseInt(process.env[envKey] || '', 10);
  return Number.isFinite(raw) ? raw : fallback;
}

export const runtimeEnv = {
  string: runtimeString,
  int: runtimeInt,
};
